import { PrivacyPolicy } from '@/components/screens';
import { GetStaticProps, NextPage } from 'next';

const PrivacyPolicyPage: NextPage = () => {
	return <PrivacyPolicy />;
};

export const getStaticProps: GetStaticProps = async () => {
	return { props: {} };
};

export default PrivacyPolicyPage;
